import { Loadable } from '../../../Loadable';

export const AsyncAddPartner = Loadable(() => import('./Add'));
// export const AsyncEditPartner = Loadable(() => import('./Edit'));
export const AsyncPartnerList = Loadable(() => import('./List'));
